// extracted by mini-css-extract-plugin
export default {"container":"DocumentsStatusInformationBanner_container__csx-H"};